import React from 'react';
import { Dialog, T } from '@colonist/ui';
import styles from './DeviceInfoDialog.module.scss';
/* Dialog with user device info */ export function DeviceInfoDialog({ open, onClose, width, height, userAgent, platform, cookieEnabled, buildNumber, portraitMode, statusBarHeight, safeAreaInsetBottom }) {
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose
    }, /*#__PURE__*/ React.createElement(Dialog.Title, null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.deviceInfo.title'
        }
    })), /*#__PURE__*/ React.createElement(Dialog.Content, null, /*#__PURE__*/ React.createElement("div", {
        className: styles.stats
    }, /*#__PURE__*/ React.createElement("p", {
        className: styles.stat
    }, /*#__PURE__*/ React.createElement("b", null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.deviceInfo.dimensions'
        }
    }), ": "), width, " x ", height), /*#__PURE__*/ React.createElement("p", {
        className: styles.stat
    }, /*#__PURE__*/ React.createElement("b", null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.deviceInfo.userAgent'
        }
    }), ": "), userAgent), platform != undefined && /*#__PURE__*/ React.createElement("p", {
        className: styles.stat
    }, /*#__PURE__*/ React.createElement("b", null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.deviceInfo.platform'
        }
    }), ": "), platform), cookieEnabled != undefined && /*#__PURE__*/ React.createElement("p", {
        className: styles.stat
    }, /*#__PURE__*/ React.createElement("b", null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.deviceInfo.cookieEnabled'
        }
    }), ": "), String(cookieEnabled)), buildNumber != undefined && /*#__PURE__*/ React.createElement("p", {
        className: styles.stat
    }, /*#__PURE__*/ React.createElement("b", null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.deviceInfo.buildNumber'
        }
    }), ": "), buildNumber), portraitMode != undefined && /*#__PURE__*/ React.createElement("p", {
        className: styles.stat
    }, /*#__PURE__*/ React.createElement("b", null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.deviceInfo.portraitMode'
        }
    }), ": "), String(portraitMode)), statusBarHeight != undefined && /*#__PURE__*/ React.createElement("p", {
        className: styles.stat
    }, /*#__PURE__*/ React.createElement("b", null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.deviceInfo.statusBarHeight'
        }
    }), ": "), statusBarHeight), safeAreaInsetBottom != undefined && /*#__PURE__*/ React.createElement("p", {
        className: styles.stat
    }, /*#__PURE__*/ React.createElement("b", null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.deviceInfo.safeAreaInsetBottom'
        }
    }), ": "), safeAreaInsetBottom))));
}
